import { useEffect, useState } from "react";

/**
 * False during prerendering and on the first client render, true afterwards.
 *
 * Use it as a `key` on react-slick sliders. Slick derives its clone count and
 * track widths from `window.innerWidth` while rendering, so the markup react-snap
 * bakes at its narrow viewport does not line up with the client's first render at
 * desktop widths. React 17 patches text content during hydration but not
 * attributes, which left every card showing its own title next to another slide's
 * `src` and `href`.
 *
 * Flipping the key remounts the slider once, rebuilding the subtree from the
 * vdom so all attributes are correct. The prerendered HTML still carries the full
 * content for crawlers.
 */
export const useHydrated = () => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  return hydrated;
};
